/**
 * @file
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-7 RFC 9110 7 Routing HTTP Messages}
 */

import {
  FieldName,
  FieldType,
  integerFieldValueFormat,
  listFieldFormat,
  singleFieldFormat,
  stringFieldValueFormat,
} from "./fields";

/**
 * Connection
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-7.6.1 RFC 9110 7.6.1 Connection}
 */
export const ConnectionField = new FieldType(
  new FieldName("Connection"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Host
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-7.2 RFC 9110 7.2 Host}
 */
export const HostField = new FieldType(
  new FieldName("Host"),
  singleFieldFormat(stringFieldValueFormat),
);

/**
 * Max-Forwards
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-7.6.2 RFC 9110 7.6.2 Max-Forwards}
 */
export const MaxForwardsField = new FieldType(
  new FieldName("Max-Forwards"),
  singleFieldFormat(integerFieldValueFormat),
);

/**
 * Upgrade
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-7.8 RFC 9110 7.8 Upgrade}
 */
export const UpgradeField = new FieldType(
  new FieldName("Upgrade"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Via
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-7.6.3 RFC 7.6.3 Via}
 */
export const ViaField = new FieldType(
  new FieldName("Via"),
  listFieldFormat(stringFieldValueFormat),
);
